import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ApiResult } from '@/infra/api'
import { hostClient } from '../api/client'
import { HOST_QUERY_KEYS } from '../api/queryKeys'
import type { HostAddRequest, HostAddResponse } from '../types'

export interface UseHostAdditionReturn {
  readonly addHost: (request: HostAddRequest) => void
  readonly addHostAsync: (request: HostAddRequest) => Promise<ApiResult<HostAddResponse>>
  readonly isAdding: boolean
  readonly error: string | null
  readonly addedHost: HostAddResponse | null
  readonly reset: () => void
}

export function useHostAddition(): UseHostAdditionReturn {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: hostClient.addHost,
    onSuccess: (result) => {
      if (result.success) {
        void queryClient.invalidateQueries({ queryKey: HOST_QUERY_KEYS.list() })
        void queryClient.invalidateQueries({ queryKey: ['settings', 'hosts'] })
      }
    },
  })

  return {
    addHost: mutation.mutate,
    addHostAsync: mutation.mutateAsync,
    isAdding: mutation.isPending,
    error: mutation.data?.success === false ? mutation.data.message : null,
    addedHost: mutation.data?.success ? mutation.data.data : null,
    reset: mutation.reset,
  }
}
